export const CHANGE_STEP = 'CHANGE_STEP'

export const RECEIVE_ADDRESSES = 'RECEIVE_ADDRESSES'
export const SET_ADRESSES_LOADING = 'SET_ADRESSES_LOADING'

export const FIELD_CHANGE = 'FIELD_CHANGE'
export const SAVE_STEP = 'SAVE_STEP'
export const RECOVER_FORM = 'RECOVER_FORM'

export const SET_CURRENT_USER = 'SET_CURRENT_USER'

export const OPEN_MODAL = 'OPEN_MODAL'
export const CLOSE_MODAL = 'CLOSE_MODAL'

export const NOTIFY = 'NOTIFY'
export const FADE_NOTIFICATION = 'FADE_NOTIFICATION'
export const FETCH_PRODUCTS = 'FETCH_PRODUCTS'
export const FETCH_ADDRESS_SUBSCRIPTION_PRODUCTS = 'FETCH_ADDRESS_SUBSCRIPTION_PRODUCTS'
export const FETCH_DOMICILIATION_PRODUCTS_ALL_ACCOUNTS = 'FETCH_DOMICILIATION_PRODUCTS_ALL_ACCOUNTS'

export const ACTIVATE_CAARL_TOUR = 'ACTIVATE_CAARL_TOUR'
export const DEACTIVATE_CAARL_TOUR = 'DEACTIVATE_CAARL_TOUR'